// extracted by mini-css-extract-plugin
export var ANBack = "Announcement-module--ANBack--80f20";
export var ANBackArrow = "Announcement-module--ANBackArrow--509d1";
export var ANBackText = "Announcement-module--ANBackText--11f09";
export var ANContainer = "Announcement-module--ANContainer--25772";
export var ANHeadings = "Announcement-module--ANHeadings--2c16b";
export var ANList = "Announcement-module--ANList--bf3f0";
export var AnnDescription = "Announcement-module--AnnDescription--8c3c8";
export var aboutSection = "Announcement-module--aboutSection--56df7";
export var pressContact = "Announcement-module--pressContact--59cca";
export var references = "Announcement-module--references--ac7a7";
export var shareDiv = "Announcement-module--shareDiv--426a5";
export var socialMediaIcons = "Announcement-module--socialMediaIcons--f4ce7";